// COOKIE

  function getBannerEl() {
    return document.getElementById('cookies-bar');
  }

  function removeCookies() {
    document.cookie = "cookies=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=de.worldofauteur.com; path=/;";
    document.cookie = "cookies=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=worldofauteur.com; path=/;";
    document.cookie = "cookies=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=fr.worldofauteur.com; path=/;";
    document.cookie = "cookies=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=es.worldofauteur.com; path=/;";
  }

  function setCookies() {
    document.cookie = "cookies=show; domain=de.worldofauteur.com; path=/;";
    document.cookie = "cookies=show; domain=worldofauteur.com; path=/;";
    document.cookie = "cookies=show; domain=fr.worldofauteur.com; path=/;";
    document.cookie = "cookies=show; domain=es.worldofauteur.com; path=/;";
  }

  function hideBanner(res) {
    getBannerEl().style.display = 'none';
    removeCookies();
  }

  function showBanner() {
   getBannerEl().style.display = 'block';
  }

  function handleAccept(e) {
    window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);

    document.addEventListener('trackingConsentAccepted',function() {
      console.log('trackingConsentAccepted event fired');
    });
  }

  function handleDecline() {
    window.Shopify.customerPrivacy.setTrackingConsent(false,hideBanner);
  }

  function initCookieBanner() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
    const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

    if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
      showBanner();
    }
  }

  window.Shopify.loadFeatures([
    {
      name: 'consent-tracking-api',
      version: '0.1',
    }
  ],
  function(error) {
    if (error) {
      throw error;
    }

    function checkCookies() {
      const domains = ["de.worldofauteur.com", "worldofauteur.com", "fr.worldofauteur.com", "es.worldofauteur.com"];
      for (let i = 0; i < domains.length; i++) {
        let cookies = document.cookie.split(';');
        for (let j = 0; j < cookies.length; j++) {
          let cookie = cookies[j].trim();
          if (cookie.indexOf('cookies=show') === 0) {
            return true;
          }
        }
      }
      return false;
    }

    if (checkCookies()) {
      showBanner();
    }
   
    initCookieBanner();
  });

  
  // Cookies after submit orbe form

  const cookieRequirementCountries = [
    "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR",
    "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL",
    "PL", "PT", "RO", "SK", "SI", "ES", "SE","GB", "CA", "AU",
    "NO", "SE", "SZ"
  ];

  document.addEventListener('DOMContentLoaded', function() {
    const orbeCountryList = document.getElementById("orbeCountryList");
    const countryNames = orbeCountryList.querySelectorAll('[data-country]');
    countryNames.forEach((country) => {
        country.addEventListener('click', (event) => {
            const clickedElement = event.currentTarget; 
            const countryValue = clickedElement.getAttribute('data-country'); 
            if (cookieRequirementCountries.includes(countryValue)) {
                setCookies();
            } else {
                removeCookies();
            }
        });
    });
  });






